import { Stack } from "../Stack";
import LoadingSpinner from "@vfuk/core-loading-spinner";

const CenteredLoadingSpinner = () => (
  <Stack justifyContent="center">
    <LoadingSpinner size={4} />
  </Stack>
);

export default CenteredLoadingSpinner;
